<p *ngIf="error" role="alert" class="text-danger">{{ error }}</p>
<tt-page *ngIf="page">
    <tt-card class="col-xs-12 sp-0">
        <h2 *ngIf="page.w_srfollowupforward_info > ''" class="checklist-h2">{{ page.w_srfollowupforward_info | uppercase }}</h2>
        <tt-input ttLabel="experience_keyno" [ttModel]="page.experience_keyno" ttReadonly></tt-input>
        <tt-input ttLabel="special_hrsno" [ttModel]="page.special_hrsno" ttReadonly></tt-input>
        <tt-textarea ttLabel="note" [(ttModel)]="page.note"></tt-textarea>
        <tt-select ttLabel="special_resource_id_to_new" [(ttModel)]="page.special_resource_id_to_new" [ttData]="resources" ttDataId="item_id" ttDataName="item_name"></tt-select>
        <tt-button-save ttText="srfollowupforward_send" [ttLoading]="sending" (ttClick)="send()" ttTextAlign="center"></tt-button-save>
    </tt-card>
</tt-page>
